import { Text } from '@mantine/core'

import { useCurrencyAmounts } from '@/hooks/business/useCurrencyAmounts'
import type { CoinOverall } from '@/types/coin'
import { formatMarketCap } from '@/utils/number/format'

import { useCoinsTableStore } from '../../context'

interface Props {
  coin: Pick<CoinOverall, 'usd_volume_24h' | 'symbol' | 'slug'>
}

export default function VolumeColumn({ coin }: Props) {
  const liveUsdVolume = useCoinsTableStore(
    state => state.liveCoinsMarket[coin.slug]?.usd_volume_24h,
  )
  const volume = liveUsdVolume ?? coin.usd_volume_24h

  const {
    amounts: [{ formattedValue }],
  } = useCurrencyAmounts({
    amounts: [volume],
    tokenSymbol: coin.symbol,
    valueFormatter: formatMarketCap,
    currencyFormatOptions: {},
  })

  return <Text variant="body1">{formattedValue}</Text>
}
